module.exports = "/images/nb.svg";